// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-pages-Project-Settings-Dashboards-WidgetsSelection-___styles-module__container {
  min-width: 600px;
  padding: 10px;
}

.app-pages-Project-Settings-Dashboards-WidgetsSelection-___styles-module__icon {
  color: rgb(178, 185, 199);
  margin-right: 10px;
}
`, "",{"version":3,"sources":["webpack://./app/pages/Project/Settings/Dashboards/WidgetsSelection/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB","sourcesContent":[".container {\n  min-width: 600px;\n  padding: 10px;\n}\n\n.icon {\n  color: rgb(178, 185, 199);\n  margin-right: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `app-pages-Project-Settings-Dashboards-WidgetsSelection-___styles-module__container`,
	"icon": `app-pages-Project-Settings-Dashboards-WidgetsSelection-___styles-module__icon`
};
export default ___CSS_LOADER_EXPORT___;
